import {Box, Button} from '@mui/material';
import React, { FC } from 'react';
import Modal from '@/components/Modal';
import ImagePreviewer from './ImagePreviewer';
import SVGDownload from "@/assets/icons/SVGDownload.tsx";
import { downloadFile } from '@/utils/downloadFile';

type Props = {
  isOpen: boolean;
  toggleModal: () => void;
  fileName: string;
  path: string;
  previewUrl: string;
}

const FilePreviewModal: FC<Props> = ({
  isOpen,
  toggleModal,
  fileName,
  path,
  previewUrl,
}) => {

  const handleDownloadFile = () => {
    downloadFile(path, fileName);
  }

  return (
    <Modal
      open={isOpen}
      onClose={toggleModal}
      title={fileName}
      boxSx={{
        maxWidth: "1000px",
        width: { xs: "calc(100% - 40px)" },
      }}
    >
      <Box sx={{ mt: 2 }}>
        <ImagePreviewer url={previewUrl} alt={`Preview of ${fileName}`} />
        <Box sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          mt: 2
        }}>
          <Button
            onClick={handleDownloadFile}
            startIcon={<SVGDownload />}
            variant="outlined"
          >
            Download
          </Button>
        </Box>
      </Box>
    </Modal>
  )
};

export default FilePreviewModal;